import { useState } from "react";

// Faithful port of the DIG design-system GameCard (components/game/GameCard.jsx).
const DECK_META = {
  PARTNER: { label: "PARTNER", accent: "#1B7FA8", tint: "#DEEDF4", onAccent: "#fff", icon: "icon-handshake.png" },
  PAIN: { label: "PAIN", accent: "#F2695C", tint: "#FDE7E4", onAccent: "#fff", icon: "icon-pain.png" },
  TRIBE: { label: "TRIBE", accent: "#2EC4B6", tint: "#DFF6F4", onAccent: "#fff", icon: "icon-tribe.png" },
  TOOL: { label: "TOOL", accent: "#FDBB2F", tint: "#FEF2D8", onAccent: "#12333F", icon: "icon-tool.png" },
  TWIST: { label: "TWIST", accent: "#12333F", tint: "#E3E9EB", onAccent: "#fff", icon: "icon-twist.png" },
};

const SIZE_WIDTH = { sm: 140, md: 200, lg: 248 };

// Branded card back (harbour ground, turquoise inset rule, white three-card mark).
export function CardBack({ width, size = "md", tilt = 0, style, onClick, className = "" }) {
  const w = width || SIZE_WIDTH[size] || 200;
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        width: w, aspectRatio: "63 / 88", borderRadius: w * 0.067, background: "#12333F",
        position: "relative", display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden", boxSizing: "border-box", flex: "none",
        boxShadow: "0 1px 3px rgba(18,51,63,.10), 0 4px 12px rgba(18,51,63,.12)",
        transform: tilt ? `rotate(${tilt}deg)` : undefined, ...style,
      }}
    >
      <div style={{ position: "absolute", inset: w * 0.045, border: "2px solid #2EC4B6", opacity: 0.5, borderRadius: w * 0.045, pointerEvents: "none" }} />
      <img src="/dig/DIG-Mark-Cards-White.svg" alt="" style={{ width: w * 0.5, transform: "rotate(-4deg)" }} />
      <div style={{ position: "absolute", bottom: w * 0.07, fontSize: w * 0.05, fontWeight: 700, letterSpacing: "0.16em", color: "#9DB4BC" }}>DIG</div>
    </div>
  );
}

export function GameCard({ category, code, es, en, isBlank = false, blankText = "", onClick, className = "", size = "md", width, tilt = 0, lang = "es" }) {
  const [hover, setHover] = useState(false);
  const w = width || SIZE_WIDTH[size] || 200;
  const meta = DECK_META[category] || DECK_META.PARTNER;
  const lift = hover && !!onClick;

  const primary = isBlank ? blankText : (lang === "en" ? en : es);
  const secondary = isBlank ? "" : (lang === "en" ? es : en);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={`game-card-${code || category}`}
      className={className}
      style={{
        width: w,
        aspectRatio: "63 / 88",
        borderRadius: w * 0.067,
        overflow: "hidden",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        fontFamily: "'Poppins', sans-serif",
        flex: "none",
        cursor: onClick ? "pointer" : undefined,
        boxShadow: lift ? "0 6px 24px rgba(18,51,63,.18)" : "0 1px 3px rgba(18,51,63,.10), 0 4px 12px rgba(18,51,63,.12)",
        transform: `rotate(${lift ? tilt * 0.3 : tilt}deg) translateY(${lift ? -w * 0.03 : 0}px)`,
        transition: "transform 200ms cubic-bezier(.2,.8,.3,1), box-shadow 200ms cubic-bezier(.2,.8,.3,1)",
      }}
    >
      {/* header: deck label + code */}
      <div style={{ background: meta.accent, color: meta.onAccent, padding: `${w * 0.045}px ${w * 0.07}px`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: w * 0.052, fontWeight: 700, letterSpacing: "0.13em" }}>{meta.label}</span>
        {code ? (
          <span style={{ fontSize: w * 0.042, fontWeight: 600, background: meta.onAccent === "#fff" ? "rgba(255,255,255,.22)" : "rgba(18,51,63,.14)", borderRadius: 999, padding: `${w * 0.008}px ${w * 0.035}px` }}>{code}</span>
        ) : null}
      </div>

      {/* body: icon circle + primary text */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: w * 0.035, padding: `${w * 0.05}px ${w * 0.08}px` }}>
        <div style={{ width: w * 0.24, height: w * 0.24, borderRadius: "50%", background: meta.tint, display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
          <img src={`/dig/icons/${meta.icon}`} alt="" style={{ width: w * 0.16, mixBlendMode: "multiply" }} />
        </div>
        {isBlank && !blankText ? (
          <div style={{ display: "grid", gap: w * 0.09 }}>
            {[0, 1, 2].map((i) => <div key={i} style={{ borderBottom: `2px solid ${meta.tint}` }} />)}
          </div>
        ) : (
          <div style={{ fontSize: w * 0.064, fontWeight: 600, lineHeight: 1.28, color: "#12333F" }}>{primary}</div>
        )}
      </div>

      {/* footer band: secondary language + mark */}
      <div style={{ background: meta.tint, padding: `${w * 0.045}px ${w * 0.08}px`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, minHeight: w * 0.19, boxSizing: "border-box" }}>
        <div style={{ fontSize: w * 0.048, fontWeight: 300, lineHeight: 1.3, color: "#12333F" }}>
          {isBlank ? "Escribe la tuya · Write your own" : secondary}
        </div>
        <img src="/dig/DIG-Mark-Small.svg" alt="" style={{ width: w * 0.1, flex: "none" }} />
      </div>
    </div>
  );
}
